// ============================================
// Modelo de datos para VentasDetalle
// ============================================
export class VentasDetalle {
  constructor(data = {}) {
    console.log('🔍 VentasDetalle constructor - data recibido:', data);
    console.log('🔍 VentasDetalle constructor - keys disponibles:', Object.keys(data));
    
    // ✅ MAPEO CORRECTO PARA TU API (minúsculas primero)
    this.Id_ventasD = data.id_ventasD || data.Id_ventasD || data.ID_VENTASD || data.idVentasD || 0;
    this.Id_Ventas = data.id_ventas || data.Id_Ventas || data.ID_VENTAS || data.idVentas || 0;
    this.Id_producto = data.id_producto || data.Id_producto || data.ID_PRODUCTO || data.idProducto || 0;
    this.Cant = data.cant || data.Cant || data.CANT || data.cantidad || 0;
    this.NombreP = data.nombreP || data.NombreP || data.NOMBREP || data.nombre_producto || '';
    this.PrecioU = data.precioU || data.PrecioU || data.PRECIOU || data.precio_unitario || 0;
    this.PrecioT = data.precioT || data.PrecioT || data.PRECIOT || data.precio_total || 0;
    this.TotalVenta = data.totalVenta || data.TotalVenta || data.TOTALVENTA || data.total_venta || 0;
    this.Estado = data.estado || data.Estado || data.ESTADO || data.status || 'ACTIVO';
    this.Estatus = data.estatus || data.Estatus || data.ESTATUS || 'PENDIENTE';
    this.Fecha = data.fecha || data.Fecha || data.FECHA || null;
    this.Hora = data.hora || data.Hora || data.HORA || null;
    this.Notas = data.notas || data.Notas || data.NOTAS || '';
    
    console.log('🔍 VentasDetalle constructor - objeto creado:', {
      Id_ventasD: this.Id_ventasD,
      Id_Ventas: this.Id_Ventas,
      Id_producto: this.Id_producto,
      Cant: this.Cant,
      NombreP: this.NombreP,
      PrecioU: this.PrecioU,
      PrecioT: this.PrecioT,
      TotalVenta: this.TotalVenta,
      Estado: this.Estado,
      Estatus: this.Estatus,
      Fecha: this.Fecha,
      Hora: this.Hora,
      Notas: this.Notas
    });
    
    // ✅ VALIDAR QUE SE MAPEARON CORRECTAMENTE
    if (!this.Id_ventasD && data.Id_ventasD !== 0) {
      console.warn('⚠️ ADVERTENCIA: Id_ventasD no se pudo mapear. Data original:', data);
    }
    if (!this.Id_Ventas && data.Id_Ventas !== 0) {
      console.warn('⚠️ ADVERTENCIA: Id_Ventas no se pudo mapear. Data original:', data);
    }
    if (!this.Id_producto && data.Id_producto !== 0) {
      console.warn('⚠️ ADVERTENCIA: Id_producto no se pudo mapear. Data original:', data);
    }
  }

  // Validaciones
  isValid() {
    const isValid = 
      this.Id_Ventas > 0 &&
      this.Id_producto > 0 &&
      this.Cant > 0 &&
      this.NombreP.trim() !== '' &&
      this.NombreP.length <= 150 &&
      this.PrecioU > 0 &&
      this.PrecioT > 0 &&
      this.TotalVenta > 0 &&
      this.Estado.trim() !== '' &&
      this.Estado.length <= 20 &&
      this.Estatus.trim() !== '' &&
      this.Estatus.length <= 20;
    
    if (!isValid) {
      console.warn('⚠️ Validación fallida:', {
        Id_Ventas: this.Id_Ventas > 0,
        Id_producto: this.Id_producto > 0,
        Cant: this.Cant > 0,
        NombreP_not_empty: this.NombreP.trim() !== '',
        NombreP_length: this.NombreP.length <= 150,
        PrecioU: this.PrecioU > 0,
        PrecioT: this.PrecioT > 0,
        TotalVenta: this.TotalVenta > 0,
        Estado_not_empty: this.Estado.trim() !== '',
        Estado_length: this.Estado.length <= 20,
        Estatus_not_empty: this.Estatus.trim() !== '',
        Estatus_length: this.Estatus.length <= 20
      });
    }
    
    return isValid;
  }

  // Validaciones individuales para mensajes específicos
  getValidationErrors() {
    const errors = [];
    
    if (!this.Id_Ventas || this.Id_Ventas <= 0) {
      errors.push('El ID de ventas es requerido');
    }
    if (!this.Id_producto || this.Id_producto <= 0) {
      errors.push('El ID de producto es requerido');
    }
    if (!this.Cant || this.Cant <= 0) {
      errors.push('La cantidad es requerida y debe ser mayor a 0');
    }
    if (!this.NombreP || this.NombreP.trim() === '') {
      errors.push('El nombre del producto es requerido');
    }
    if (this.NombreP && this.NombreP.length > 150) {
      errors.push('El nombre del producto no puede exceder 150 caracteres');
    }
    if (!this.PrecioU || this.PrecioU <= 0) {
      errors.push('El precio unitario es requerido y debe ser mayor a 0');
    }
    if (!this.PrecioT || this.PrecioT <= 0) {
      errors.push('El precio total es requerido y debe ser mayor a 0');
    }
    if (!this.TotalVenta || this.TotalVenta <= 0) {
      errors.push('El total de venta es requerido y debe ser mayor a 0');
    }
    if (!this.Estado || this.Estado.trim() === '') {
      errors.push('El estado es requerido');
    }
    if (this.Estado && this.Estado.length > 20) {
      errors.push('El estado no puede exceder 20 caracteres');
    }
    if (!this.Estatus || this.Estatus.trim() === '') {
      errors.push('El estatus es requerido');
    }
    if (this.Estatus && this.Estatus.length > 20) {
      errors.push('El estatus no puede exceder 20 caracteres');
    }
    
    return errors;
  }

  // ✅ MÉTODO PARA PUT/POST - AJÚSTALO SEGÚN EL FORMATO QUE ESPERA TU API
  toApiFormat() {
    return {
      id_ventasD: this.Id_ventasD,
      id_ventas: this.Id_Ventas,
      id_producto: this.Id_producto,
      cant: this.Cant,
      nombreP: this.NombreP,
      precioU: this.PrecioU,
      precioT: this.PrecioT,
      totalVenta: this.TotalVenta,
      estado: this.Estado,
      estatus: this.Estatus,
      fecha: this.Fecha,
      hora: this.Hora,
      notas: this.Notas
    };
  }

  // ✅ MÉTODO PARA DEBUG MEJORADO
  toDebug() {
    return {
      'Frontend (mayúsculas)': {
        Id_ventasD: this.Id_ventasD,
        Id_Ventas: this.Id_Ventas,
        Id_producto: this.Id_producto,
        Cant: this.Cant,
        NombreP: this.NombreP,
        PrecioU: this.PrecioU,
        PrecioT: this.PrecioT,
        TotalVenta: this.TotalVenta,
        Estado: this.Estado,
        Estatus: this.Estatus,
        Fecha: this.Fecha,
        Hora: this.Hora,
        Notas: this.Notas
      },
      'API Format (minúsculas)': this.toApiFormat(),
      'Is Valid': this.isValid(),
      'Validation Errors': this.getValidationErrors()
    };
  }

  // ✅ MÉTODO ÚTIL: Calcular precio total basado en cantidad y precio unitario
  calcularPrecioTotal() {
    this.PrecioT = this.Cant * this.PrecioU;
    return this.PrecioT;
  }
}